// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AppstoreFilledSvg from "@ant-design/icons-svg/es/asn/AppstoreFilled";
import AntdIcon from '../components/AntdIcon';

var AppstoreFilled = function AppstoreFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AppstoreFilledSvg
  }));
};

AppstoreFilled.displayName = 'AppstoreFilled';
export default React.forwardRef(AppstoreFilled);